module.exports = __webpack_public_path__ + "img/calendar.07ffb6f8.svg";